module.exports = __webpack_public_path__ + "img/logo_alt.55473722.svg";